export class DiscountCodeApplicationRepresentation {

  public readonly discountCodeString: string;

  constructor(discountCodeString: string) {
    this.discountCodeString = discountCodeString;
  }

}
